export class RegularExpressions {
  public static ONLY_NUMBERS = '^[0-9]*$';
  public static ONLY_NUMBERS_AND_LETTERS = '^[a-zA-Z0-9]*$';
  public static ONLY_LETTERS = '^[a-zA-Z]([\s]?[a-zA-Z])*$';
  public static ONLY_NUMBER_CELLPHONE = '3[0-9]{9}';
  public static PHONE_RES_LENGTH = '^([0-9]{7}|[0-9]{10})$';
  public static VALIDATE_EMAIL = '[a-zA-Z0-9_-]+([.][a-zA-Z0-9_-]+)*@[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{2,5}$';
  public static VALIDATE_ADDRESS = '^((?!CALLE)(?!CARRERA)[A-Z]{2,8}[\ ])+((([0-9]{1,3})?([\ ]?[a-zA-Z\ ]*)?([\ ]?[0-9]{1,3})([\ ]?[a-zA-Z]{1})?([\ ]?)([\ ]?[0-9]{1,3})([\ ]?[a-zA-Z]{2,5})?([\ ]?[0-9]{1,3})?)?([A-Z\ ]{2,5}([A-Za-z\ ][0-9]*){1,60})?)$';
  public static VALIDATE_EXT = '^.*\.(xls|xlsx)$';
  public static ONLY_LETTERS_ESPECIAL_CHARTS = '^[a-zA-Z-áéíóúÁÉÍÓÚñÑ]+( [a-zA-Z-áéíóúÁÉÍÓÚñÑ]+)*$';
  public static FORMAT_DATE_VALID = '/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[1-9]|2[1-9])$/';
  public static CARACTER_VALIDO = '^[a-zA-Z0-9# -]+$';
}
